function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import px from '../utility/px.js';
import { reportError } from '../utility/debug.js';
export default function useStyle(style, _ref) {
  var tbody = _ref.tbody,
      state = _ref.state;

  if (tbody) {
    return style;
  } // Validate that the passed `style` property doesn't include
  // `padding-top` or `padding-bottom` or `padding`.


  if (style) {
    if (typeof style.padding === 'number') {
      reportError('`style` property can\'t include any `padding`');
    }

    if (typeof style.paddingTop === 'number') {
      reportError('`style` property can\'t include any `paddingTop`');
    }

    if (typeof style.paddingBottom === 'number') {
      reportError('`style` property can\'t include any `paddingBottom`');
    }
  }

  var beforeItemsHeight = state.beforeItemsHeight,
      afterItemsHeight = state.afterItemsHeight;
  return _objectSpread(_objectSpread({}, style), {}, {
    paddingTop: px(beforeItemsHeight),
    paddingBottom: px(afterItemsHeight)
  });
}
//# sourceMappingURL=useStyle.js.map